const ITEMS = [
    "FRESH COTTON CANDY",
    "GOURMET POPCORN",
    "NYC + BROOKLYN",
    "PARTIES",
    "CORPORATE EVENTS",
    "WEDDINGS",
    "WHOLESALE",
    "MYSTERY FLAVORS",
];

export const Marquee = ({ inverted = false }) => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className={`overflow-hidden py-4 border-y ${
                inverted
                    ? "bg-ink text-white border-zinc-800"
                    : "bg-pink text-ink border-pink-dark"
            }`}
        >
            <div className="flex w-max animate-marquee whitespace-nowrap">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="font-oswald text-lg md:text-xl tracking-[0.2em] uppercase px-6 flex items-center gap-6"
                    >
                        {item}
                        <span className={inverted ? "text-pink" : "text-ink/60"}>✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
